var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreePackageService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 145.445,
    viewBox: "0 0 250 145.445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1141",
    "data-name": "Group 1141",
    transform: "translate(-587.651 -372.762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1134",
    "data-name": "Group 1134",
    transform: "translate(698.209 372.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M790.143,414.789h-2.519V386.611a11.33,11.33,0,1,0-22.66,0v28.178h-2.519V386.611a13.85,13.85,0,0,1,27.7,0Z",
    transform: "translate(-747.86 -372.762)",
    fill: "#6f38d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_700",
    "data-name": "Rectangle 700",
    d: "M0,0H37.454a0,0,0,0,1,0,0V93.773a0,0,0,0,1,0,0H3.133A3.133,3.133,0,0,1,0,90.639V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 32.696)",
    fill: "#572680"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_701",
    "data-name": "Rectangle 701",
    width: 82.292,
    height: 93.773,
    transform: "translate(19.234 32.696)",
    fill: "#572680"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_702",
    "data-name": "Rectangle 702",
    width: 18.22,
    height: 93.773,
    transform: "translate(19.234 32.696)",
    fill: "#6f38d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M844.681,414.789h-2.519V386.611a11.33,11.33,0,1,0-22.66,0v28.178h-2.519V386.611a13.85,13.85,0,0,1,27.7,0Z",
    transform: "translate(-763.352 -372.762)",
    fill: "#6f38d4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_538",
    "data-name": "Ellipse 538",
    cx: 2.304,
    cy: 2.304,
    r: 2.304,
    transform: "translate(52.588 40.143)",
    fill: "#6f38d4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_539",
    "data-name": "Ellipse 539",
    cx: 2.304,
    cy: 2.304,
    r: 2.304,
    transform: "translate(77.766 39.724)",
    fill: "#6f38d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1136",
    "data-name": "Group 1136",
    transform: "translate(763.887 430.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M846.356,477.878H835.673a1.864,1.864,0,0,0-1.854,2.055l2.912,28.288a2.513,2.513,0,0,0,2.5,2.256h10.063Z",
    transform: "translate(-833.809 -460.517)",
    fill: "#bc5006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M889.026,518.067l.377-5.523H837.1l.568,5.523a2.521,2.521,0,0,0,2.278,2.256h46.668A2.422,2.422,0,0,0,889.026,518.067Z",
    transform: "translate(-834.743 -470.364)",
    fill: "#993a14",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1135",
    "data-name": "Group 1135",
    transform: "translate(9.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M870.313,453.629h0v.005c4.236,0,8.024,2.654,10.725,6.941a29.551,29.551,0,0,1,4.12,13.718h-2.55a26.871,26.871,0,0,0-3.727-12.359c-2.237-3.555-5.272-5.755-8.568-5.755v0h0v0c-3.3,0-6.33,2.2-8.567,5.753a26.864,26.864,0,0,0-3.724,12.36h-2.552a29.526,29.526,0,0,1,4.12-13.718c2.7-4.287,6.488-6.94,10.722-6.94v-.005Z",
    transform: "translate(-849.462 -453.629)",
    fill: "#dd691b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M901.169,508.22l1.938-28.42a1.8,1.8,0,0,0-1.8-1.922H847.079l2.1,30.8a1.927,1.927,0,0,0,1.922,1.8h47.652A2.422,2.422,0,0,0,901.169,508.22Z",
    transform: "translate(-847.079 -460.517)",
    fill: "#e25b00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M901.841,518.067l.377-5.523H849.443l.409,6a1.906,1.906,0,0,0,1.9,1.777h47.671A2.422,2.422,0,0,0,901.841,518.067Z",
    transform: "translate(-847.75 -470.364)",
    fill: "#8c3002",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M883.454,453.629h0v.005c4.236,0,8.024,2.654,10.725,6.941a28.938,28.938,0,0,1,4,12.292,1.28,1.28,0,0,1-1.265,1.425h0a1.281,1.281,0,0,1-1.266-1.162,26.318,26.318,0,0,0-3.625-11.2c-2.238-3.555-5.271-5.755-8.568-5.755v0h0v0c-3.3,0-6.329,2.2-8.567,5.753a26.333,26.333,0,0,0-3.623,11.2A1.281,1.281,0,0,1,870,474.293h0a1.28,1.28,0,0,1-1.264-1.425,28.9,28.9,0,0,1,4-12.293c2.7-4.287,6.488-6.94,10.722-6.94v-.005Z",
    transform: "translate(-853.227 -453.629)",
    fill: "#f9751c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M863.941,485.841H862.9l.734-.735a.235.235,0,1,0-.333-.331l-.734.733v-1.037a.235.235,0,1,0-.47,0v1.037l-.734-.733a.235.235,0,1,0-.332.331l.734.735h-1.038a.235.235,0,1,0,0,.47h1.038l-.734.734a.235.235,0,0,0,.332.332l.734-.734v1.038a.235.235,0,0,0,.47,0v-1.038l.734.734a.235.235,0,0,0,.333-.332l-.734-.734h1.037a.235.235,0,1,0,0-.47Z",
    transform: "translate(-841.39 -462.323)",
    fill: "#ff8533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M879.11,485.841h-1.037l.734-.735a.235.235,0,1,0-.332-.331l-.734.733v-1.037a.235.235,0,1,0-.47,0v1.037l-.734-.733a.235.235,0,1,0-.333.331l.734.735H875.9a.235.235,0,0,0,0,.47h1.037l-.734.734a.235.235,0,0,0,.333.332l.734-.734v1.038a.235.235,0,0,0,.47,0v-1.038l.734.734a.235.235,0,0,0,.332-.332l-.734-.734h1.037a.235.235,0,0,0,0-.47Z",
    transform: "translate(-845.699 -462.323)",
    fill: "#ff8533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M894.279,485.841h-1.037l.734-.735a.235.235,0,1,0-.332-.331l-.734.733v-1.037a.235.235,0,1,0-.47,0v1.037l-.734-.733a.235.235,0,1,0-.333.331l.735.735H891.07a.235.235,0,1,0,0,.47h1.038l-.735.734a.235.235,0,0,0,.333.332l.734-.734v1.038a.235.235,0,1,0,.47,0v-1.038l.734.734a.235.235,0,1,0,.332-.332l-.734-.734h1.037a.235.235,0,1,0,0-.47Z",
    transform: "translate(-850.008 -462.323)",
    fill: "#ff8533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M909.448,485.841h-1.037l.735-.735a.235.235,0,1,0-.333-.331l-.734.733v-1.037a.235.235,0,1,0-.47,0v1.037l-.734-.733a.235.235,0,1,0-.332.331l.734.735h-1.038a.235.235,0,0,0,0,.47h1.038l-.734.734a.235.235,0,0,0,.332.332l.734-.734v1.038a.235.235,0,0,0,.47,0v-1.038l.734.734a.235.235,0,0,0,.333-.332l-.735-.734h1.037a.235.235,0,0,0,0-.47Z",
    transform: "translate(-854.316 -462.323)",
    fill: "#ff8533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M871.525,494.394h-1.037l.735-.735a.235.235,0,1,0-.333-.332l-.734.734v-1.038a.235.235,0,0,0-.47,0v1.038l-.734-.734a.235.235,0,1,0-.333.332l.735.735h-1.038a.234.234,0,1,0,0,.469h1.038l-.735.735a.235.235,0,0,0,.333.332l.734-.734v1.038a.235.235,0,0,0,.47,0V495.2l.734.734a.235.235,0,0,0,.333-.332l-.735-.735h1.037a.234.234,0,1,0,0-.469Z",
    transform: "translate(-843.544 -464.752)",
    fill: "#ff8533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M886.7,494.394h-1.038l.735-.735a.235.235,0,1,0-.333-.332l-.734.734v-1.038a.235.235,0,0,0-.47,0v1.038l-.734-.734a.235.235,0,1,0-.332.332l.734.735h-1.038a.234.234,0,1,0,0,.469h1.038l-.734.735a.235.235,0,0,0,.332.332l.734-.734v1.038a.235.235,0,0,0,.47,0V495.2l.734.734a.235.235,0,0,0,.333-.332l-.735-.735H886.7a.234.234,0,1,0,0-.469Z",
    transform: "translate(-847.853 -464.752)",
    fill: "#ff8533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M901.864,494.394h-1.037l.734-.735a.235.235,0,1,0-.333-.332l-.734.734v-1.038a.234.234,0,1,0-.469,0v1.038l-.734-.734a.235.235,0,1,0-.333.332l.734.735h-1.038a.234.234,0,1,0,0,.469h1.038l-.734.735a.235.235,0,0,0,.333.332l.734-.734v1.038a.234.234,0,1,0,.469,0V495.2l.734.734a.235.235,0,0,0,.333-.332l-.734-.735h1.037a.234.234,0,1,0,0-.469Z",
    transform: "translate(-852.162 -464.752)",
    fill: "#ff8533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M917.033,494.394H916l.734-.735a.235.235,0,1,0-.332-.332l-.734.734v-1.038a.235.235,0,0,0-.47,0v1.038l-.734-.734a.235.235,0,1,0-.333.332l.735.735h-1.038a.234.234,0,1,0,0,.469h1.038l-.735.735a.235.235,0,0,0,.333.332l.734-.734v1.038a.235.235,0,0,0,.47,0V495.2l.734.734a.235.235,0,0,0,.332-.332l-.734-.735h1.037a.234.234,0,1,0,0-.469Z",
    transform: "translate(-856.471 -464.752)",
    fill: "#ff8533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M864.684,503.505h-1.037l.735-.734a.235.235,0,1,0-.333-.332l-.734.734v-1.038a.235.235,0,1,0-.47,0v1.038l-.734-.734a.235.235,0,1,0-.332.332l.734.734h-1.038a.235.235,0,1,0,0,.47h1.038l-.734.734a.235.235,0,0,0,.332.332l.734-.734v1.038a.235.235,0,0,0,.47,0v-1.038l.734.734a.235.235,0,0,0,.333-.332l-.735-.734h1.037a.235.235,0,1,0,0-.47Z",
    transform: "translate(-841.601 -467.341)",
    fill: "#ff8533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M879.854,503.505h-1.037l.734-.734a.235.235,0,1,0-.333-.332l-.734.734v-1.038a.235.235,0,1,0-.47,0v1.038l-.734-.734a.235.235,0,1,0-.332.332l.734.734h-1.038a.235.235,0,1,0,0,.47h1.038l-.734.734a.235.235,0,0,0,.166.4.234.234,0,0,0,.166-.069l.734-.734v1.038a.235.235,0,0,0,.47,0v-1.038l.734.734a.235.235,0,0,0,.333-.332l-.734-.734h1.037a.235.235,0,1,0,0-.47Z",
    transform: "translate(-845.91 -467.341)",
    fill: "#ff8533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M895.023,503.505h-1.037l.734-.734a.235.235,0,1,0-.332-.332l-.734.734v-1.038a.235.235,0,1,0-.47,0v1.038l-.734-.734a.235.235,0,1,0-.333.332l.734.734h-1.038a.235.235,0,0,0,0,.47h1.038l-.734.734a.235.235,0,0,0,.333.332l.734-.734v1.038a.235.235,0,0,0,.47,0v-1.038l.734.734a.235.235,0,1,0,.332-.332l-.734-.734h1.037a.235.235,0,0,0,0-.47Z",
    transform: "translate(-850.219 -467.341)",
    fill: "#ff8533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M910.192,503.505h-1.037l.734-.734a.235.235,0,1,0-.332-.332l-.734.734v-1.038a.235.235,0,1,0-.47,0v1.038l-.734-.734a.235.235,0,1,0-.333.332l.735.734h-1.038a.235.235,0,0,0,0,.47h1.038l-.735.734a.235.235,0,0,0,.333.332l.734-.734v1.038a.235.235,0,1,0,.47,0v-1.038l.734.734a.235.235,0,1,0,.332-.332l-.734-.734h1.037a.235.235,0,1,0,0-.47Z",
    transform: "translate(-854.528 -467.341)",
    fill: "#ff8533"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1137",
    "data-name": "Group 1137",
    transform: "translate(756.416 480.618)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_703",
    "data-name": "Rectangle 703",
    width: 81.235,
    height: 37.161,
    fill: "#f1b776"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_704",
    "data-name": "Rectangle 704",
    width: 24.966,
    height: 37.161,
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_705",
    "data-name": "Rectangle 705",
    width: 11.002,
    height: 4.515,
    transform: "translate(62.241 25.768)",
    fill: "#faffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_706",
    "data-name": "Rectangle 706",
    width: 4.515,
    height: 4.515,
    transform: "translate(32.18 25.768)",
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_707",
    "data-name": "Rectangle 707",
    width: 4.515,
    height: 4.515,
    transform: "translate(38.36 25.768)",
    fill: "#a55927"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1138",
    "data-name": "Group 1138",
    transform: "translate(656.963 442.053)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_708",
    "data-name": "Rectangle 708",
    width: 111.957,
    height: 75.725,
    transform: "translate(0)",
    fill: "#f1b776"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_709",
    "data-name": "Rectangle 709",
    width: 34.408,
    height: 75.725,
    transform: "translate(0)",
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_710",
    "data-name": "Rectangle 710",
    width: 15.163,
    height: 6.222,
    transform: "translate(85.78 60.023)",
    fill: "#faffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_711",
    "data-name": "Rectangle 711",
    width: 6.222,
    height: 6.222,
    transform: "translate(44.35 60.023)",
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_712",
    "data-name": "Rectangle 712",
    width: 6.222,
    height: 6.222,
    transform: "translate(52.868 60.023)",
    fill: "#a55927"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M697.238,530.567s6.962.294,6.367,7.587,1.548,13.574,1.191,15.314-.467,2.455-.467,2.455,2.153,4.077,0,6.681h-6.438l-1.534-11.079Z",
    transform: "translate(-30.878 -44.825)",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1139",
    "data-name": "Group 1139",
    transform: "translate(587.651 480.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M610.087,547.339A91.609,91.609,0,0,0,634.013,524a1.342,1.342,0,0,1,2.247.031c1.887,3.067,1.346,7.28.407,8.782-.987,1.579-20.595,14.225-24.868,16.97a1.336,1.336,0,0,1-1.57-.092l-.25-.2A1.337,1.337,0,0,1,610.087,547.339Z",
    transform: "translate(-593.854 -523.41)",
    fill: "#a52919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M601.963,548.827s5.146.684,12.566-2.875c8.929-4.282,17.493-16.162,21.256-16.054,2.691.08,7.968.839,12.984.415a5.285,5.285,0,0,1,5.74,5.735c-.373,3.946-1.27,6.689-.9,9.35.554,3.986,1.549,10.737-.553,13.284s-39.08.775-39.08.775l-15.387-3.431Z",
    transform: "translate(-590.757 -525.252)",
    fill: "#d65945"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M636.476,529.9c-3.763-.108-12.326,11.772-21.256,16.054-7.42,3.559-12.566,2.875-12.566,2.875l-1.634,3.484,3.056,1.611s10.111.148,22.45-8.856a65.752,65.752,0,0,0,15.031-14.808C639.5,530.115,637.713,529.935,636.476,529.9Z",
    transform: "translate(-591.448 -525.252)",
    fill: "#c43826"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M668.867,552.226c-3.946.544-12.908,3.011-16.795,14.174,8.021.014,15.275-.289,16.175-1.375C670.267,562.58,669.427,556.253,668.867,552.226Z",
    transform: "translate(-605.95 -531.595)",
    fill: "#f4502a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M591.29,558.8s2.5-3.086,11.729-2.567c1.356,3.071-.216,6.134-1.4,6.28A74.772,74.772,0,0,1,591.29,558.8Z",
    transform: "translate(-588.684 -532.716)",
    fill: "#c43826"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M636.8,571.347c-4.679,0-9.672-.074-14.383-.151-4.4-.068-8.553-.132-12.105-.132-9.019,0-18.864-3.942-21.811-5.219a1.408,1.408,0,0,1-.848-1.415,5.746,5.746,0,0,1,2.6-4.59c.851.319,10.921,5.024,20.059,5.024,3.6,0,7.779.065,12.2.134,10.412.162,26.985.178,28.536-.339,1.677,1.473,1.363,3.838,1,5.169a1.47,1.47,0,0,1-1.291,1.089C647.11,571.244,642.162,571.347,636.8,571.347Z",
    transform: "translate(-587.651 -533.758)",
    fill: "#d6736b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M652.44,568.921a5.726,5.726,0,0,0-.032-.89c-6.9.688-19.724.551-31.073.427-3.981-.042-7.739-.083-10.917-.083-9.748,0-21.9-5.477-22.014-5.529a.386.386,0,0,0-.352.23.493.493,0,0,0,.059.488c.115.054,12.36,5.7,22.307,5.7,3.172,0,6.929.038,10.907.083,4.555.049,9.345.1,13.9.1C642.013,569.444,648.274,569.329,652.44,568.921Z",
    transform: "translate(-587.754 -534.611)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M636.629,565.3c-4.839,0-9.8-.047-13.215-.1-4.415-.067-8.581-.134-12.2-.134-3.8,0-10.306-.841-19.7-4.848-.233-.1-.395-.167-.473-.2a.332.332,0,1,1,.233-.622c.083.031.253.1.5.208,9.292,3.964,15.7,4.8,19.442,4.8,3.62,0,7.789.066,12.206.135,11,.171,27,.155,28.427-.322a.332.332,0,1,1,.208.631C651.013,565.191,643.953,565.3,636.629,565.3Z",
    transform: "translate(-588.553 -533.625)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M621.644,555.639a1.16,1.16,0,1,1-1.623-.226A1.159,1.159,0,0,1,621.644,555.639Z",
    transform: "translate(-596.714 -532.434)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    d: "M626.2,552.187a1.161,1.161,0,1,1-1.625-.225A1.16,1.16,0,0,1,626.2,552.187Z",
    transform: "translate(-598.007 -531.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M630.747,548.735a1.161,1.161,0,1,1-1.625-.223A1.159,1.159,0,0,1,630.747,548.735Z",
    transform: "translate(-599.3 -530.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    d: "M635.3,545.284a1.16,1.16,0,1,1-1.624-.223A1.163,1.163,0,0,1,635.3,545.284Z",
    transform: "translate(-600.593 -529.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M639.85,541.834a1.159,1.159,0,1,1-1.625-.226A1.161,1.161,0,0,1,639.85,541.834Z",
    transform: "translate(-601.886 -528.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M644.4,538.384a1.161,1.161,0,1,1-1.626-.224A1.16,1.16,0,0,1,644.4,538.384Z",
    transform: "translate(-603.178 -527.533)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M637.652,531.026c-.112.137-.224.273-.337.41a.37.37,0,0,0-.009.46l4.11,5.42a.631.631,0,1,0,1.006-.763l-4.186-5.518A.371.371,0,0,0,637.652,531.026Z",
    transform: "translate(-601.734 -525.534)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M633.892,535.37l-.441.485a.3.3,0,0,0-.018.392l3.627,4.781a.63.63,0,1,0,1-.76l-3.7-4.879A.309.309,0,0,0,633.892,535.37Z",
    transform: "translate(-600.637 -526.778)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    d: "M629.876,539.635l-.371.372a.365.365,0,0,0-.032.482l3.2,4.22a.631.631,0,1,0,1.006-.762l-3.244-4.279A.37.37,0,0,0,629.876,539.635Z",
    transform: "translate(-599.509 -527.987)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    d: "M625.791,543.563q-.242.223-.481.441a.3.3,0,0,0-.036.407l2.95,3.894a.632.632,0,0,0,1.007-.763l-2.989-3.942A.305.305,0,0,0,625.791,543.563Z",
    transform: "translate(-598.32 -529.111)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M621.494,547.38q-.23.2-.457.387a.329.329,0,0,0-.049.452l2.762,3.64a.63.63,0,0,0,1-.761l-2.78-3.668A.332.332,0,0,0,621.494,547.38Z",
    transform: "translate(-597.101 -530.196)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M617.065,550.988l-.462.359a.335.335,0,0,0-.062.469l2.685,3.542a.632.632,0,1,0,1.006-.765l-2.688-3.545A.339.339,0,0,0,617.065,550.988Z",
    transform: "translate(-595.837 -531.223)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M663.073,544.259a2.916,2.916,0,1,1-2.917-2.917A2.916,2.916,0,0,1,663.073,544.259Z",
    transform: "translate(-607.418 -528.503)",
    fill: "#f16a4d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1140",
    "data-name": "Group 1140",
    transform: "translate(607.687 480.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    d: "M638.087,547.339A91.609,91.609,0,0,0,662.013,524a1.342,1.342,0,0,1,2.247.031c1.887,3.067,1.346,7.28.407,8.782-.987,1.579-20.595,14.225-24.868,16.97a1.336,1.336,0,0,1-1.57-.092l-.25-.2A1.337,1.337,0,0,1,638.087,547.339Z",
    transform: "translate(-621.844 -523.41)",
    fill: "#e8390a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    d: "M629.963,548.827s5.146.684,12.566-2.875c8.929-4.282,17.493-16.162,21.256-16.054,2.691.08,7.968.839,12.984.415a5.285,5.285,0,0,1,5.74,5.735c-.373,3.946-1.27,6.689-.9,9.35.554,3.986,1.549,10.737-.553,13.284s-39.08.775-39.08.775l-15.387-3.431Z",
    transform: "translate(-618.747 -525.252)",
    fill: "#f16a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    d: "M664.476,529.9c-3.763-.108-12.326,11.772-21.256,16.054-7.42,3.559-12.566,2.875-12.566,2.875l-1.634,3.484,3.056,1.611s10.111.148,22.45-8.856a65.752,65.752,0,0,0,15.031-14.808C667.5,530.115,665.713,529.935,664.476,529.9Z",
    transform: "translate(-619.438 -525.252)",
    fill: "#f4502a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    d: "M696.867,552.226c-3.946.544-12.908,3.011-16.795,14.174,8.021.014,15.275-.289,16.175-1.375C698.267,562.58,697.427,556.253,696.867,552.226Z",
    transform: "translate(-633.94 -531.595)",
    fill: "#f4502a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    d: "M619.29,558.8s2.363-3.071,11.588-2.553c1.357,3.071-.322,6.068-1.236,6.315C626.835,561.609,619.29,558.8,619.29,558.8Z",
    transform: "translate(-616.674 -532.721)",
    fill: "#f4502a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    d: "M664.8,571.347c-4.679,0-9.672-.074-14.383-.151-4.4-.068-8.553-.132-12.105-.132-9.158,0-19.167-4.064-21.942-5.276a1.21,1.21,0,0,1-.73-1.185,5.815,5.815,0,0,1,2.613-4.762c.851.319,10.921,5.024,20.059,5.024,3.6,0,7.779.065,12.2.134,10.412.162,26.985.178,28.536-.339,1.677,1.473,1.363,3.838,1,5.169a1.47,1.47,0,0,1-1.291,1.089C675.106,571.244,670.158,571.347,664.8,571.347Z",
    transform: "translate(-615.637 -533.758)",
    fill: "#fca89d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M680.428,568.886a5.734,5.734,0,0,0-.032-.89c-6.9.688-19.724.551-31.073.427-3.981-.042-7.739-.083-10.917-.083-9.748,0-21.857-5.565-21.971-5.617a.477.477,0,0,0-.42.261.626.626,0,0,0,.073.576c.115.054,12.372,5.667,22.318,5.667,3.172,0,6.929.038,10.907.083,4.555.049,9.345.1,13.9.1C670,569.409,676.262,569.294,680.428,568.886Z",
    transform: "translate(-615.732 -534.576)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M664.629,565.3c-4.839,0-9.8-.047-13.215-.1-4.415-.067-8.581-.134-12.2-.134-3.8,0-10.306-.841-19.7-4.848-.233-.1-.395-.167-.473-.2a.332.332,0,1,1,.233-.622c.083.031.253.1.5.208,9.292,3.964,15.7,4.8,19.442,4.8,3.62,0,7.789.066,12.206.135,11,.171,27,.155,28.427-.322a.332.332,0,1,1,.208.631C679.013,565.191,671.953,565.3,664.629,565.3Z",
    transform: "translate(-616.542 -533.625)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M649.644,555.639a1.16,1.16,0,1,1-1.623-.226A1.159,1.159,0,0,1,649.644,555.639Z",
    transform: "translate(-624.704 -532.434)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M654.2,552.187a1.161,1.161,0,1,1-1.625-.225A1.16,1.16,0,0,1,654.2,552.187Z",
    transform: "translate(-625.997 -531.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M658.747,548.735a1.161,1.161,0,1,1-1.625-.223A1.159,1.159,0,0,1,658.747,548.735Z",
    transform: "translate(-627.29 -530.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M663.3,545.284a1.16,1.16,0,1,1-1.624-.223A1.163,1.163,0,0,1,663.3,545.284Z",
    transform: "translate(-628.583 -529.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M667.85,541.834a1.159,1.159,0,1,1-1.625-.226A1.161,1.161,0,0,1,667.85,541.834Z",
    transform: "translate(-629.876 -528.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M672.4,538.384a1.161,1.161,0,1,1-1.626-.224A1.16,1.16,0,0,1,672.4,538.384Z",
    transform: "translate(-631.168 -527.533)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M665.679,530.978q-.193.237-.388.472a.332.332,0,0,0-.009.412l4.129,5.444a.631.631,0,1,0,1.006-.763l-4.216-5.557A.332.332,0,0,0,665.679,530.978Z",
    transform: "translate(-629.719 -525.525)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M661.937,535.3q-.265.294-.531.583a.24.24,0,0,0-.014.309l3.66,4.824a.63.63,0,1,0,1-.76l-3.746-4.942A.243.243,0,0,0,661.937,535.3Z",
    transform: "translate(-628.62 -526.763)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M657.949,539.526q-.261.264-.522.523a.261.261,0,0,0-.022.344l3.254,4.293a.631.631,0,1,0,1.006-.762l-3.317-4.375A.264.264,0,0,0,657.949,539.526Z",
    transform: "translate(-627.485 -527.965)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    d: "M653.834,543.5q-.29.27-.576.53a.236.236,0,0,0-.029.32l2.986,3.941a.632.632,0,0,0,1.007-.763l-3.032-4A.242.242,0,0,0,653.834,543.5Z",
    transform: "translate(-626.301 -529.098)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    d: "M649.552,547.3q-.3.255-.592.5a.242.242,0,0,0-.036.331l2.813,3.706a.63.63,0,0,0,1-.761l-2.836-3.742A.243.243,0,0,0,649.552,547.3Z",
    transform: "translate(-625.078 -530.18)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    d: "M645.129,550.91c-.211.164-.417.325-.621.481a.236.236,0,0,0-.043.33l2.745,3.621a.632.632,0,1,0,1.006-.765l-2.75-3.626A.237.237,0,0,0,645.129,550.91Z",
    transform: "translate(-623.811 -531.206)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M692.789,543.132a5.757,5.757,0,1,1-5.76-5.756A5.757,5.757,0,0,1,692.789,543.132Z",
    transform: "translate(-634.281 -527.377)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M692.075,543.6a4.576,4.576,0,1,1-4.578-4.577A4.577,4.577,0,0,1,692.075,543.6Z",
    transform: "translate(-634.749 -527.845)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    d: "M691.073,544.259a2.916,2.916,0,1,1-2.917-2.917A2.916,2.916,0,0,1,691.073,544.259Z",
    transform: "translate(-635.408 -528.503)",
    fill: "#f16a4d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    d: "M713.569,463.384l-12.121-15.529H665.8l13.362,15.529Z",
    transform: "translate(-22.198 -21.33)",
    fill: "#f1b776"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    d: "M758.04,463.423l12.476-15.431h59.546l-12.742,15.431Z",
    transform: "translate(-48.4 -21.369)",
    fill: "#a55927"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreePackageService);
export default __webpack_public_path__ + "static/media/free-package-service.f730f85c12b08c67492c5ee6657f53f8.svg";
export { ForwardRef as ReactComponent };